export const LOCAL_STORAGE_KEYS = {
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  THEME_PALETTE: 'theme_palette',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  WHATS_NEW_SEEN: 'whats_new_seen',
  SYSTEM_BANNER_DISMISSED: 'systemBannerDismissed',
};
